export const IN_PERSON_SUFFIX = ' • In-person';
export const UPCOMING_TODAY_HEADER = 'Upcoming today';
export const EMPTY_CARD_MESSAGE = "Take a break, you're done for the day!";
export const ERROR_CARD_MESSAGE = 'Schedule is unavailable until we can connect you.';
